import React, { Component } from 'react';
import { compose, withState, lifecycle, withHandlers } from 'recompose';
import Iframe from 'react-iframe';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';

import Popup from '../Popup';
import { commonStyles, COLORS } from '../../styles/styles';
import { STATUSES, STORAGE_LINK, STORAGE_LINK2 } from '../../constants';
import { statusCode } from '../../utils';
import IframeComm from 'react-iframe-comm';
import {
  selectAssessment, selectUserContent, getUserProgramsFullRequest, selectAssessmentContent, selectRollout, setCost, selectUserModule, toggleExamComplete, submitMCQ, selectItem
} from '../../redux/reducers/userProgramsFull';
import {
  saveTimeTaken,
  addComponentStatusRequest,
  saveStatus,
} from '../../redux/reducers/addComponentStatus';

import {
  assignmentRequestRequest, setMediaType
} from '../../redux/reducers/assignmentRequest';

import PDFTron from '../PDFTron';

import split from '../../assets/split.svg';

import {
  saveAnnotationRequest,
  saveBookmarksRequest,
  selectAnnotationSave,
  selectBookmarksSave
} from '../../redux/reducers/annotations';

import { selectedModule, selectedContent, selectedModuleId, selectedProgramId } from '../../redux/selectors';

import {Rnd} from 'react-rnd'
import { MDBIcon } from 'mdbreact';
import { printReportFailure } from '../../redux/reducers/savedVersions';
import { setDeleteIndex, setPopUps, showSaveModal } from '../../redux/reducers/view';
import { xapiRequest } from '../../redux/reducers/xapi';
import { contentItemRequest } from '../../redux/reducers/contentList';
import ExamTimer from '../ExamTimer';
import { loginReducer } from '../../redux/reducers/login';
var sha1 = require('sha1');
class ZoomPopup extends Component {
 
constructor(props){
  super(props)
  
  this.refObj = {}
  this.refObj[props.zDepth] = React.createRef()
}
render(){
  const {
    selectedContent: { type: contentType },
    classes,
    handlePopupToggle,
    pathToIframeFile,
    selectedContent,
    handleMessage,
    handlePauseVideo,
    saveStatus,
    handleUpdateStatus,
    handlePDFTRONSENDMessage,
    user,
    submitMCQ,
    getUserComponent,
    viewAssignment,
    selectedAttempt,
    getHTMLPath,
    selectUserContent,
    handlePDFTRONMessage,
    logbookImage,
    handleMinimize,
    minimized,
    saveTimeTaken,
    addComponentStatusRequest,
    getUserProgramsFullRequest,
    zDepth,
    onDrag,
    onDragStart,
    onDragStop,
    setDeleteIndex,
    isMobile,
    isDragged,
    submitMCQRequest

  } = this.props;

  const postMessageData = {msg:'LOGBOOKIMAGE',img:logbookImage};
  try {
    var checksum = sha1('joinfullName='+escape(user.user.firstName+' '+user.user.lastName)+'&meetingID='+selectedContent.meeting_id+'&password='+selectedContent.password+'&redirect=truey0wiq50aUjh5Un9cFR0ewUl9Xog9uPXrJMQJCK80Pw')
  } catch (error) {
    
  }
  var exam = 0;
  if(selectedContent.survey_exam==true || selectedContent.survey_supplementary==true){
    exam=1;
  }
  const refObj = {};
  {  console.log('KKKJHH', handlePopupToggle)}
  return <Popup style={{height:'100%', width:'100%', }} zDepth={selectedContent.type=='Webinar' ? 900 : 1000-zDepth} index={zDepth}>
 <Rnd
      ref={c => { this.rnd = c; }}
      default={{
        x: 0,
        y: 0,
        width: '100%',
        height: '100%',
      }}
      style={{ zIndex: 999, pointerEvents: 'all' }}
      minWidth={200}
      minHeight={50}
      onDrag={onDrag}
      bounds="parent">
    <div className="popupHolder">
      <div className="iframePopup">
      
      <div className={classes.popupHeader}>
        <div style={{position:'absolute', left:0, top:10}}>
        {!minimized ? <h6 className='text-white text-left pl-3 pb-2'>
              {String(selectedContent.name).substring(0, 30)+'...'}
            </h6> :  <h6 className='text-white text-left pl-3 pb-2'>
              {String(selectedContent.name).substring(0, 20)+'...'}
            </h6>
        } 
        </div>
  
        {/* <div style={{paddingRight:10, paddingTop:10, cursor:'pointer'}} onClick={() => {
          let elem =  document.querySelector('#popup-container')
          let rect = elem.getBoundingClientRect();
          {}
          this.rnd.updateSize({ width: rect.width/2, height: rect.bottom });
                
          this.rnd.updatePosition({ x: (rect.right/2), y: 0 });
           
           //  handleMinimize();
            }}>
        <img src={split} style={{height:18}}/>
        </div> */}
       
      {!minimized ? <MDBIcon onTouchStart={() => {
          console.log('NOWNOWNOW2')
        let elem =  document.querySelector('#popup-container')
        let rect = elem.getBoundingClientRect();
              
               this.rnd.updateSize({ width: 300, height: 210 });
               
             if(isDragged==false){
              
              this.rnd.updatePosition({ x: (rect.right-(330*(zDepth+1))), y: rect.bottom-300 });
             }else{
              
              this.rnd.updatePosition({ x: isDragged.xPos, y: isDragged.yPos });
             }
            
             handleMinimize();
            }} id='minIcon' icon="window-minimize" style={{height:20, cursor:'pointer'}} className={classes.closePopup} onClick={() => {
          console.log('NOWNOWNOW2')
        let elem =  document.querySelector('#popup-container')
        let rect = elem.getBoundingClientRect();
              
               this.rnd.updateSize({ width: 300, height: 210 });
               
             if(isDragged==false){
              
              this.rnd.updatePosition({ x: (rect.right-(330*(zDepth+1))), y: rect.bottom-300 });
             }else{
              
              this.rnd.updatePosition({ x: isDragged.xPos, y: isDragged.yPos });
             }
            
             handleMinimize();
            }}/> :
            <MDBIcon icon="window-maximize" style={{height:20}} className={classes.closePopup} onTouchStart={() => {
              let elem =  document.querySelector('#popup-container')
              let rect = elem.getBoundingClientRect();
                     
                   this.rnd.updateSize({ width: '100%', height: '100%' });
                  
                   this.rnd.updatePosition({ x: 0, y: 0 });
                   handleMinimize();
                  }} onClick={() => {
              let elem =  document.querySelector('#popup-container')
              let rect = elem.getBoundingClientRect();
                     
                   this.rnd.updateSize({ width: '100%', height: '100%' });
                  
                   this.rnd.updatePosition({ x: 0, y: 0 });
                   handleMinimize();
                  }}/>}
          <Clear
            className={classes.closePopup}
            onTouchStart = {() => {
             
              selectUserContent(selectedContent.contentId)
              if (selectedContent) {
                if(selectedContent.type=='Document'){
                  handlePDFTRONSENDMessage(selectedContent, this)
                }else if (Object.keys(selectedContent).length > 1) {
                  console.log('popup kill me',zDepth)
                  setDeleteIndex(zDepth)
                  handlePopupToggle(selectedContent, true);
                } else {
                  console.log('popup kill me 2',zDepth)
                  setDeleteIndex(zDepth)
                  console.log('MY MESSAGE 3')
                  handlePopupToggle(false, true);
                }
                if (
                  saveStatus &&
                  (contentType === 'Image' ||
                    contentType === 'jpg' ||
                    contentType === 'png' ||
                    contentType === 'Document' ||
                    contentType === 'HTML Captivate' ||
                    contentType === 'HTML Articlulate')
                ) {
                  
                  saveStatus(STATUSES.completed.value);
                }
                if(selectedContent.type=='Webinar' && selectedContent.mediaUrl==null){
                  saveStatus(STATUSES.completed.value);
                }
                if (contentType!='Assignments' && contentType!='Survey' && contentType!='WSR Assessments') {
                  
                 //saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
                  //addComponentStatusRequest();
                }else{
                  
                }
              }
            
              getUserComponent()
            }}
          
            onClick={() => {
              console.log('MINI',selectedContent)
              selectUserContent(selectedContent.contentId)
              if (selectedContent) {
                if(selectedContent.type=='Document'){
                  handlePDFTRONSENDMessage(selectedContent, this)
                }else if (Object.keys(selectedContent).length > 1) {
                  console.log('popup kill me',zDepth)
                  setDeleteIndex(zDepth)
                  console.log('popup kill me 2',zDepth)
                  handlePopupToggle(selectedContent, true);
                } else {
                  console.log('SPLICE8',zDepth)
                  setDeleteIndex(zDepth)
                  console.log('MY MESSAGE 4')
                  handlePopupToggle(false, true);
                }
                if (
                  saveStatus &&
                  (contentType === 'Image' ||
                    contentType === 'jpg' ||
                    contentType === 'png' ||
                    contentType === 'Document' ||
                    contentType === 'HTML Captivate' ||
                    contentType === 'HTML Articlulate')
                ) {
                  
                  saveStatus(STATUSES.completed.value);
                }

                if(selectedContent.type=='Webinar' && selectedContent.mediaUrl==null){
                  saveStatus(STATUSES.completed.value);
                }
                if (contentType!='Assignments' && contentType!='Survey' && contentType!='WSR Assessments') {
                  
                 //saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
                  //addComponentStatusRequest();
                }else{
                  
                }
              }
            
              getUserComponent()
            }}
          />
         
        </div>
        <div className={classes.iframeContainer}>
          {console.log('ZOOM', 'https://bbb.cpslearn.co.za/bigbluebutton/api/join?meetingID='+selectedContent.meeting_id+'&password='+selectedContent.password+'&fullName='+user.user.firstName+' '+user.user.lastName+'&checksum='+checksum)}
          
         
        {(selectedContent.type === 'Webinar'  && selectedContent.mediaUrl==null) && (
          
           <IframeComm attributes={ { allow:"camera;microphone",src: 'https://bbb.cpslearn.co.za/bigbluebutton/api/join?fullName='+escape(user.user.firstName+' '+user.user.lastName)+'&meetingID='+selectedContent.meeting_id+'&password='+selectedContent.password+'&redirect=true&checksum='+checksum,
           width: "100%",
           height: "100%",
        }}
        
     handleReceiveMessage={handleMessage} />
       )
      }
      {(selectedContent.type === 'Webinar'  && selectedContent.mediaUrl!=null) && (
           <IframeComm attributes={ { allow:"camera;microphone",src: selectedContent.mediaUrl,
           width: "100%",
           height: "100%",
        }}
        
     handleReceiveMessage={handleMessage} />
      )}

      
      
      
        {(selectedContent.type === 'Assignments' && submitMCQ) && (
           <IframeComm attributes={ {src: process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=1'+'&logbook=0&exam='+exam,
           width: "100%",
           height: "100%",
        }}
        
     handleReceiveMessage={handleMessage} />
         // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
          //  <Iframe className={classes.iframePopup} url={process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0' }/>
          )}

{(selectedContent.type === 'WSR Assessments' && submitMCQ) && (
           <IframeComm  postMessageData={postMessageData} attributes={ {src: process.env.REACT_APP_MY_VAR+'/survey/surveyview_js.html?sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=1'+'&logbook=1&file='+logbookImage+'&exam='+exam,
           width: "100%",
           height: "100%",
        }}
        
     handleReceiveMessage={handleMessage} />
           )}

{(selectedContent.type === 'Survey') && (
           <IframeComm attributes={ {src: process.env.REACT_APP_MY_VAR+'survey/surveyview_generator.html?pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&logbook=0&exam='+exam,
           width: "100%",
           height: "100%",
        }}
        
     handleReceiveMessage={handleMessage} />
          )}

{(selectedContent.type === 'HTML Captivate' || selectedContent.type === 'HTML Articlulate') && (
           <IframeComm attributes={ {src: getHTMLPath(selectedContent.path),
            width: "100%",
            height: "100%",
        }}
        
     handleReceiveMessage={handleMessage} />
            )}
           
           {(selectedContent.type === 'Assignments' && !submitMCQ && !viewAssignment) && (
           <div style={{height:"100%"}}>{console.log('SHOWSURVEY')}<IframeComm attributes={ {src: process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0'+'&logbook=0&exam='+exam,
            width: "100%",
            height: "100%",
        }}
        
     handleReceiveMessage={handleMessage} /><div style={{position: "absolute",top: 10,zIndex: 2030,right: 10}}>{(selectedContent.survey_exam == true || selectedContent.survey_supplementary ==true)&& <ExamTimer endTime={selectedContent.end_date}/>}</div></div>
         // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
          //  <Iframe className={classes.iframePopup} url={process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0' }/>
          )}
           {(selectedContent.type === 'Assignments' && !submitMCQ && viewAssignment && selectedContent.survey_exam === false && selectedContent.survey_supplementary ===false) && (
           <IframeComm attributes={ {src: process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0&editable=0&attempt='+selectedAttempt+'&logbook=0&exam='+exam,
            width: "100%",
            height: "100%",
        }} 
        
        
     />
         // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
          //  <Iframe className={classes.iframePopup} url={process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0' }/>
          )}
          {(selectedContent.type === 'Assignments' && !submitMCQ && viewAssignment && (selectedContent.survey_exam === true || selectedContent.survey_supplementary ==true)) && (
           <IframeComm attributes={ {src: process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0&logbook=0&exam=1',
            width: "100%",
            height: "100%",
        }} 
        
        
     />
         // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
          //  <Iframe className={classes.iframePopup} url={process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0' }/>
          )}
          {(selectedContent.type === 'WSR Assessments' && !submitMCQ && !viewAssignment) && (
           <IframeComm  attributes={ {src: process.env.REACT_APP_MY_VAR+'/survey/surveyview_js.html?pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0'+'&logbook=1&exam='+exam,
            width: "100%",
            height: "100%",
        }}
        
     handleReceiveMessage={handleMessage} />
          )}
           {(selectedContent.type === 'WSR Assessments' && !submitMCQ && viewAssignment) && (
           <IframeComm attributes={ {src: process.env.REACT_APP_MY_VAR+'/survey/surveyview_js.html?pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0&editable=0&attempt='+selectedAttempt+'&logbook=0&exam='+exam,
            width: "100%",
            height: "100%",
        }}
        
     />
          )}
         {console.log('What', selectedContent)}
          {(selectedContent.type === 'Document' && !selectedContent.pdf_collab) && (
              <IframeComm  ref={(ref) => { this.refObj[zDepth] = ref }} attributes={ {src: process.env.REACT_APP_MY_VAR+'viewer/?name='+user.user.firstName+' '+user.user.lastName+'&url='+selectedContent.path+'&pdf_json='+selectedContent.pdf_json+'&pdf_bookmark='+selectedContent.bookmark_json,
              width: "100%",
              height: "100%",
           }}
           
           
        handleReceiveMessage={handlePDFTRONMessage} />
          )}
             {(selectedContent.type === 'Document' && selectedContent.pdf_collab==1) && (
              <IframeComm  ref={(ref) => { this.refObj[zDepth] = ref }} attributes={ {src: 'https://collaboration.cpslearn.co.za/?name='+user.user.firstName+' '+user.user.lastName+'&url='+selectedContent.path+'&DOCUMENT_ID='+selectedContent.rollout_id+'_'+selectedContent.contentId+'&pdf_bookmark='+STORAGE_LINK+selectedContent.bookmark_json,
              width: "100%",
              height: "100%",
           }}
        handleReceiveMessage={handlePDFTRONMessage} />
          )}
          {}
          {(selectedContent.type === 'Image' ||
            selectedContent.type === 'png' ||
            selectedContent.type === 'jpg') && (
            <img className={classes.image} src={pathToIframeFile} alt={pathToIframeFile} />
          )}
          {selectedContent.type === 'Video' && (
            <ReactPlayer
              className={classes.videoPopup}
              url={STORAGE_LINK2+pathToIframeFile}
              onPause={handlePauseVideo}
              onProgress={e => handleUpdateStatus(e)}
              onEnded={() => {
                saveStatus(STATUSES.completed.value);
                addComponentStatusRequest();
                console.log('MY MESSAGE 6')
                handlePopupToggle(selectedContent, true);
              }}
              controls
              playing
            />
          )}
        </div>
      </div>
    </div>
    </Rnd>
  </Popup>

}
};

const styles = () => ({
  ...commonStyles,
  image: {
    margin: '0 auto',
    display: 'block',
    maxWidth: 1200,
    width: '98%',
  },
  iframeContainer: {
    backgroundColor:"#FFF",
    position: 'absolute',
    overflow: 'scroll',
    top:34,
    bottom:0,
    left:0,
    right:0
  },
  videoPopup: {
    width: '100%!important',
    height: '100%!important',
  },

  popupIframe: {
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    width: '100%',
    height: '100%',
    position: 'relative',
    zIndex: 10,
  },
  popupHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems:'center',
    backgroundColor:COLORS.yellow
  },
  closePopup: {
    color: '#fff',
    background: 'transparent',
    alignSelf: 'flex-end',
    cursor: 'pointer',
    margin: '10px 5px 0 0',
  },
});
const mapDispatchToProps = dispatch => ({
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  setMediaType: surveyId => dispatch(setMediaType(surveyId)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  saveStatus: status => dispatch(saveStatus(status)),
  setCost: status => dispatch(setCost(status)),
  assignmentRequestRequest: type => dispatch(assignmentRequestRequest(type)),
  selectAnnotationSave: json => dispatch(selectAnnotationSave(json)),
  selectBookmarksSave: json => dispatch(selectBookmarksSave(json)),
  saveAnnotationRequest: () => dispatch(saveAnnotationRequest()),
  saveBookmarksRequest: () => dispatch(saveBookmarksRequest()),
  setDeleteIndex: (int) => dispatch(setDeleteIndex(int)),
  selectRollout: (int) => dispatch(selectRollout(int)),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
  setPopups: array => dispatch(setPopUps(array)),
  getUserComponent:() => dispatch(contentItemRequest()),
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  selectUserModule: contentId => dispatch(selectUserModule(contentId)),
  selectAssessmentContent: obj => dispatch(selectAssessmentContent(obj)),
  toggleExamComplete:bool => dispatch(toggleExamComplete(bool)),
  submitMCQRequest: value => dispatch(submitMCQ(value)),
  showSaveModal:bool => dispatch(showSaveModal(bool)),
  selectItem:bool => dispatch(selectItem(bool)),
});

const mapStateToProps = state => ({
  user: state.loginReducer,
  submitMCQ: state.userProgramsFullReducer.submitMCQ,
  selectedAttempt: state.userProgramsFullReducer.selectedAttempt,
  viewAssignment: state.userProgramsFullReducer.viewAssignment,
  logbookImage: state.userProgramsFullReducer.logbookImage,
  popups:state.viewReducer.popups,
  view: state.viewReducer,
  examComplete: state.userProgramsFullReducer.examComplete,
  assessmentContent: state.userProgramsFullReducer.assessmentContent
});
export default compose(
  withState('statusComponent', 'handleChangeStatus', 0),
  withState('startTimePdf', 'handleSpentTimePdf', 0),
  withState('minimized', 'toggleMinimize', false),
  withState('isDragged', 'isDraggedToggle', false),
  withState('isMobile', 'setIsMobile', false),
  withState('currentWidth', 'changeWidth', '100%'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handlePopupToggle: props => (item, closed, video) => {
      const { isShowPopup, xapiRequest, getUserComponent, selectedContent, selectedContent: { type: contentType  }, saveTimeTaken, addComponentStatusRequest }= props;
     
      
     
      //xapiRequest({ xapiType: `${xapiType}`});
      if (isShowPopup) {
        //getUserComponent()
        console.log('SHOW POPUP', selectedContent)
        props.selectItem(selectedContent)
      }
      
      if (
        saveStatus &&
        (contentType === 'Image' ||
          contentType === 'jpg' ||
          contentType === 'png' ||
          contentType === 'Document' ||
          contentType === 'HTML Captivate' ||
          contentType === 'HTML Articlulate')
      ) {
        console.log('SPLICE ME NOW 2', contentType)
        props.showSaveModal(true)
      }
      console.log('SSS', video, contentType)
      if ((contentType!='Assignments' && contentType!='Survey' && contentType!='Webinar' && contentType!='WSR Assessments') || (video==true && contentType=='Webinar')) {
      //   saveStatus(STATUSES.completed.value);
      //  // saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
      //   addComponentStatusRequest();
      }else{
        //getUserComponent();
      }
      console.log('MY MESSAGE CLOSED', closed)
      if(closed==true){
        var itemToRemove
        console.log('Splice', props.view.windowDeleteIndex)
       // if(props.view.windowDeleteIndex){
          console.log('SpliceNOW', props.view.windowDeleteIndex)
          var tmp = props.popups;
          tmp.splice(props.view.windowDeleteIndex,1)
          console.log('Splice2',tmp)
          props.setPopups(tmp);
        //}
       
        //props.togglePopup(!isShowPopup);
        
      }else{
        
        var tmp = props.popups;
        tmp.push(item);
        props.setPopups(tmp);
        //props.togglePopup(!isShowPopup);

      }


      
    },
  }),
  withHandlers({
    
    handleAssignmentStatus: props => e => {
      const {
        addComponentStatus,
        selectedContentItem,
        addComponentStatusRequest,
        saveStatus,
        saveTimeTaken
      } = props;
      
      if(e=='in progress' && selectedContentItem.status != 'in progress'){
        console.log('MY MESSAGE HANDLE',e)
        saveStatus(STATUSES.inProgress.value);
        
        addComponentStatusRequest();
        
      }

      
      if(e==='ready' && selectedContentItem.status != 'ready'){
        
        saveStatus(STATUSES.ready.value);
        addComponentStatusRequest();
      }

      if(e==='submitted' && selectedContentItem.status != 'submitted'){
        
        saveStatus(STATUSES.submitted.value);
        addComponentStatusRequest();
      }
      if(e==='not started' && selectedContentItem.status != 'not started'){
        
        saveStatus(STATUSES.notStarted.value);
        addComponentStatusRequest();
      }
      if(e==='completed' && selectedContentItem.status != 'completed'){
        
        saveStatus(STATUSES.completed.value);
        addComponentStatusRequest();
      }
      if(e==='marking' && selectedContentItem.status != 'marking'){
        
        saveStatus(STATUSES.marking.value);
        addComponentStatusRequest();
      }

    },
    handlePauseVideo: props => () => {
      const { xapiRequest, selectedContent: item } = props;
      xapiRequest({ xapiType: `Paused${item.type}`, item });
    },
    handleUpdateStatus: props => e => {
      const { selectedContent, saveStatus, saveTimeTaken } = props;
      
      if (selectedContent.status !== STATUSES.completed.value) {
        saveStatus(STATUSES.inProgress.value);
      }
     // saveTimeTaken(Math.round(e.playedSeconds / 1000));
    },
    getHTMLPath: props => path => {
      var p = path.split('.zip')
      return p[0]+'/index.html'
    },
    onDragStop: props => e => {
      console.log('NOWNOW5', e)
      e.stopImmediatePropagation()
    
     
    },
    onDrag: props => e => {
      console.log('NOWNOW3')
      if(e.offset<0){
        props.isDraggedToggle({xPos:e.x-e.offsetX,yPos:e.y-e.offsetY})
      }else{
        props.isDraggedToggle({xPos:e.x-e.offsetX,yPos:e.y-76})
      }
      e.stopImmediatePropagation()
       
    },
    onDragStart: props => e => {
      console.log('NOWNOW4', e)
      e.stopImmediatePropagation()
     
     
    },
    handlePDFTRONMessage: props => e => {
      console.log('PDFTRON 1', e)
      try {
        var obj = JSON.parse(e.data)
      props.selectUserModule(props.selectedContent.module_id)
      props.selectRollout(props.selectedContent.rollout_id);
        console.log('PDFTRON', obj)
        if(obj.action=='Save Annotations'){
        
          props.selectAnnotationSave(obj.annotations)
          props.selectUserContent(props.selectedContent.contentId);
          console.log('handle pdf tron annotations',obj.annotations)
          console.log('handle pdf tron bookmarks', obj.bookmarks)
          props.selectBookmarksSave(obj.bookmarks)
          props.saveBookmarksRequest();
          props.saveAnnotationRequest();
          props.handlePopupToggle(props.selectedContent, true, props.zDepth);
        }
        if(obj.action=='Save Bookmarks'){
          console.log('handle pdf tron bookmarks', obj)
          props.selectBookmarksSave(obj.bookmarks)
          props.selectUserContent(props.selectedContent.contentId);
          props.saveBookmarksRequest();
          props.handlePopupToggle(props.selectedContent, true, props.zDepth);
      }
      } catch (error) {
        console.log('handle pdf tron error', error)
      }
      
    },
    handlePDFTRONSENDMessage: props => (e, p) => {
      if(!props.selectedContent.pdf_collab|| props.selectedContent.pdf_collab==0){
        console.log('Splice4', props.zDepth)
        console.log('HHH4_T')
        props.selectUserModule(props.selectedContent.module_id)
        props.selectRollout(props.selectedContent.rollout_id);
        props.setDeleteIndex(props.zDepth)
        p.refObj[props.zDepth].sendMessage('save', "*")
      }else{
        console.log('Splice4', props.zDepth)
        console.log('HHH4_T')
        props.selectUserModule(props.selectedContent.module_id)
        props.selectRollout(props.selectedContent.rollout_id);
        props.setDeleteIndex(props.zDepth)
        p.refObj[props.zDepth].sendMessage('save', "*")
      }
     
    },
    handleMinimize: props => e => {
      
      props.toggleMinimize(!props.minimized)
    },
    handleMessage: props => e => {
      const { addComponentStatusRequest, saveStatus,setCost,selectUserModule, saveTimeTaken, handleAssignmentStatus,setMediaType, selectedContent,selectRollout, submitMCQ, assignmentRequestRequest, selectAssessent, selectAssessmentContent } = props;
     
    try {
      console.log('HHHxxx',JSON.parse(e.data), selectedContent)
      var msg = JSON.parse(e.data);
    
      if(msg.action==='STATUS'){
        selectUserModule(selectedContent.module_id)
        selectRollout(selectedContent.rollout_id);
        if(msg.status==='ready' && selectedContent.status !== 'ready'){
         
          handleAssignmentStatus(msg.status);
        }else if(msg.status==='completed' && selectedContent.status !== 'completed' && selectedContent.survey_exam==false && selectedContent.survey_supplementary==false){
          if(msg.result.passed=='NYC'){
            console.log('HHH', selectedContent)
            if(selectedContent.attempts.length==0){
              if(submitMCQ==true){
                console.log('PPPSS', selectedContent)
                selectAssessment(selectedContent.survey_id);
                selectAssessmentContent(selectedContent);
                selectUserModule(selectedContent.module_id)
                selectRollout(selectedContent.rollout_id);
                setCost(selectedContent.survey_cost);
                setMediaType('document');
                assignmentRequestRequest('retake');
                saveStatus(STATUSES.notStarted.value);
                addComponentStatusRequest();
              }
            
            }else{
              console.log('HHH2', selectedContent)
              handleAssignmentStatus('submitted');
            }
          
          }else{
            selectUserModule(selectedContent.module_id)
                selectRollout(selectedContent.rollout_id);
            handleAssignmentStatus('completed');
          }
         
         
        }else if(msg.status==='in progress' && (selectedContent.status !== 'in progress' || selectedContent.status !== 'ready')){
          console.log('MY MESSAGE IN PEOGRESS', e)
          selectUserModule(selectedContent.module_id)
                selectRollout(selectedContent.rollout_id);
          handleAssignmentStatus(msg.status);
          
        }else if(msg.status==='marking' && (selectedContent.status !== 'marking')){
          
          handleAssignmentStatus(msg.status);
          
        }else if(msg.status==='completed' && (selectedContent.status !== 'marking')){
          
          handleAssignmentStatus(msg.status);
          
        }
        
        
      }else if(msg.status==='completed' && (selectedContent.status !== 'marking')){
        
        handleAssignmentStatus(msg.status);
        
      }else if(msg.status==='in progress' && (selectedContent.status !== 'in progress' || selectedContent.status !== 'ready')){
        
        handleAssignmentStatus(msg.status);
        
      }else if(selectedContent.type === 'HTML Captivate' || selectedContent.type === 'HTML Articlulate'){
        
        saveStatus(STATUSES.completed.value);
        
      }
    } catch (error) {
      
    }
     
    },
  }),
  
 
  lifecycle({
    componentDidMount() {
      const {
        contentIframe,
        saveTimeTaken,
        saveStatus,
        addComponentStatusRequest,
        handleSpentTimePdf,
        selectedContent
      } = this.props;
      if (contentIframe) {
        saveTimeTaken(0);
      }
      this.props.selectItem(selectedContent)
      this.props.xapiRequest({ xapiType: `Opened`})
      //elem.addEventListener('ontouchstart', () => console.log('MYICON'));
      let elem =  document.querySelector('#popup-container')
      let rect = elem.getBoundingClientRect();
 if(rect.width>724){
   this.props.setIsMobile(true)
 }
    },
    componentWillReceiveProps(nextProps) {
      const { addComponentStatus: thisAddComponentStatus, handlePopupToggle, zDepth, setDeleteIndex, assessmentContent } = this.props;
      const { addComponentStatus: nextAddComponentStatus, handleChangeStatus, status } = nextProps;
 
      if (this.props.examComplete==false && nextProps.examComplete==true) {
       
        this.props.submitMCQRequest(true);
        this.props.selectAssessmentContent(assessmentContent)
        this.props.selectUserContent(assessmentContent.contentId);
        this.props.selectAssessment(assessmentContent.survey_id);
    
        handlePopupToggle(assessmentContent);
      
      }
    },
    componentWillUnmount() {
      const {
        selectedContent: { type: contentType },
        contentIframe,
        saveStatus,
        saveTimeTaken,
        addComponentStatusRequest,
        startTimePdf,
      } = this.props;
      if (
        saveStatus &&
        (contentType === 'Image' ||
          contentType === 'jpg' ||
          contentType === 'png' ||
          contentType === 'Document' ||
          contentType === 'HTML Captivate' ||
          contentType === 'HTML Articlulate' ||
          contentType === 'Video')
      ) {
        // saveStatus(STATUSES.completed.value);
        console.log('SPLICE ME NOW 1', contentType)
        //this.props.showSaveModal(true)
      }
      this.props.xapiRequest({ xapiType: `Closed`})
      if (contentIframe && contentType!='Assignments' && contentType!='Survey') {
        
        saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
        //addComponentStatusRequest();
      }
    },
  }),
  withStyles(styles),
)(ZoomPopup);

ZoomPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  selectedContent: PropTypes.instanceOf(Object),
  handlePopupToggle: PropTypes.func,
  handlePauseVideo: PropTypes.func,
  handleUpdateStatus: PropTypes.func,
  saveStatus: PropTypes.func,
};
